import { useRef, useEffect } from 'react';

export const useControlledInterval = () => {
    const intervalRef = useRef<ReturnType<typeof setInterval>>();
    const isPausedRef = useRef(false);
    const callbackRef = useRef<() => void>();
    const delayRef = useRef(0);

    const start = (cb: () => void, ms: number) => {
        clearInterval(intervalRef.current);
        callbackRef.current = cb;
        delayRef.current = ms;
        isPausedRef.current = false;
        intervalRef.current = setInterval(cb, ms);
    };

    const pause = () => {
        if (intervalRef.current && !isPausedRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = undefined;
            isPausedRef.current = true;
        }
    };

    const resume = () => {
        if (isPausedRef.current && callbackRef.current && delayRef.current > 0) {
            intervalRef.current = setInterval(callbackRef.current, delayRef.current);
            isPausedRef.current = false;
        }
    };

    const clear = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = undefined;
        isPausedRef.current = false;
        callbackRef.current = undefined;
        delayRef.current = 0;
    };

    useEffect(() => clear, [])

    return { start, pause, resume, clear };
};
